import { DELETE_CART_TICKETS, SET_CART_REMAINING_TIME, SET_CART_TICKETS, SET_CONTACT_DETAILS } from '../actions';
import { SET_FORM_FIELD_ERROR_MESSAGE, SET_FORM_FIELD_VALUE, SET_FORM_FIELD_VALID } from '../actions/forms';
import { CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_INITIAL_STATE } from './features/contact-details';
import { BUY_FORM, BUY_INITIAL_STATE } from './features/buy';
import { USER_FORM, USER_INITIAL_STATE } from './features/user';

const INITIAL_STATE = {
    event: {},
    tickets: [],
    seats: [],
    total: 0,
    waitingPayment: false,
    contactDetails: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
    },
    forms: {
        [CONTACT_DETAILS_FORM_NAME]: { ...CONTACT_DETAILS_INITIAL_STATE },
        [BUY_FORM]: { ...BUY_INITIAL_STATE },
        [USER_FORM]: { ...USER_INITIAL_STATE },
    },
};

export const cartReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CART_TICKETS:
            return {
                ...state,
                ...action.payload,
            };
        case SET_CONTACT_DETAILS:
            return {
                ...state,
                contactDetails: {
                    ...state.contactDetails,
                    ...action.payload,
                },
            };
        case DELETE_CART_TICKETS:
            return INITIAL_STATE;
        case SET_FORM_FIELD_VALUE:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            value: action.value,
                            isValid: true,
                            errorMessage: null,
                        },
                    },
                },
            };
        case SET_FORM_FIELD_VALID:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            isValid: action.isValid,
                        },
                    },
                },
            };
        case SET_FORM_FIELD_ERROR_MESSAGE:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.form]: {
                        ...state.forms[action.form],
                        [action.field]: {
                            ...state.forms[action.form][action.field],
                            errorMessage: action.errorMessage,
                        },
                    },
                },
            };
        case SET_CART_REMAINING_TIME:
            return {
                ...state,
                remainingTime: action.payload,
            };
        default:
            return state;
    }
};

export default cartReducer;
